// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".spacer[data-v-77cf4a91]{margin-bottom:56px}.mb-20[data-v-77cf4a91]{margin-bottom:20px}.mt-20[data-v-77cf4a91]{margin-top:20px}.comment-wrapper[data-v-77cf4a91]{position:relative}.icon[data-v-77cf4a91]{margin-right:12px}.popUp[data-v-77cf4a91]{position:fixed!important;bottom:0!important;margin-left:-16px!important}.msg[data-v-77cf4a91]{position:fixed;bottom:56px;margin-left:-20px}", ""]);
// Exports
module.exports = exports;
